import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "../OrderProduct/OrderProduct.module.css";
import {
  faMinus,
  faPlus,
  faTrashAlt,
} from "@fortawesome/fontawesome-free-solid";

const EachOrderItem = ({ item, products, setProducts, SetNumber, number }) => {
  const [gray, setGray] = useState(false);

  /////////////delete product add/////////
  //   const removeUploadImage = (name) => {
  //     setProducts((oldState) => oldState.filter((item) => item !== name));
  //   };
  useEffect(() => {}, [item.count]);
  ///////////minus count product////////////
  const MinusCountHandler = () => {
    setGray(true);
    products.forEach((el) => {
      if (el.name === item.name) {
        if (number < 2) {
            SetNumber(0);
            item.count =0;
            setGray(false);
        } else {
          SetNumber(item.count - 1);
          item.count -= 1;
        }
      }
    });
  };

  ///////////plus count product////////////
  const PlusCountHandler = () => {
    setGray(true);
    products.forEach((el) => {
      if (el.name === item.name) {
        SetNumber(item.count + 1);
        item.count += 1;
      }
    });
  };

  /////////////delete product add/////////
  const removeUploadImage = (name) => {
    const newList =products.splice(products.findIndex(e=>e.name!==name))
    setProducts(newList)
  }

  return (
    <div className={Style.itemsProduct}>
      <FontAwesomeIcon
        onClick={() => removeUploadImage(item.name)}
        className={Style.trashIcon}
        icon={faTrashAlt}
      />
      <div className={Style.ProductCounterHolder}>
        <div className={Style.plus} onClick={PlusCountHandler}>
          <FontAwesomeIcon icon={faPlus} />
        </div>
        <input className={Style.Counter} type={"number"} value={item.count} />
        <div
          className={Style.Minus}
          onClick={gray?MinusCountHandler: null}
        >
          <FontAwesomeIcon icon={faMinus} />
        </div>
      </div>
      <p>{item.name}</p>
    </div>
  );
};
export default EachOrderItem;
